// +/- zoom buttons stacked bottom-right, above the leaflet attribution.
// `bottom` is set inline by the component. Colours resolve to the `:root`
// light-theme tokens (`--color-background` etc.) which every host in this
// monorepo defines, so the one stylesheet renders identically on the console
// and the public preview. `bordered` toggles the outline via a modifier class.
.root {
  display: flex;
  flex-direction: column;
  gap: 6px;
  position: absolute;
  right: 16px;
  z-index: 999;
}

.button {
  align-items: center;
  background-color: var(--color-background, #ffffff);
  border: 0;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
  color: var(--color-foreground, #18181b);
  cursor: pointer;
  display: flex;
  height: 40px;
  justify-content: center;
  padding: 0;
  transition: background-color 120ms ease-out;
  width: 40px;

  &:hover {
    background-color: var(--color-secondary, #f4f4f5);
  }
}

.button-bordered {
  border: 1px solid var(--color-border, #e4e4e7);
}
